import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "expand-less",
  "use": "expand-less-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"expand-less\"><path d=\"m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol